export const createItemGap = (isColumn?: boolean, itemGap?: string) =>
  itemGap &&
  `> * + * {
    margin-${isColumn ? 'top' : 'left'}: ${itemGap} !important;
  }`;
